import React, { useEffect, useRef } from 'react'

interface InstagramEmbedProps {
    url: string
}

function InstagramEmbed({ url }: InstagramEmbedProps) {
    const blockquoteRef = useRef<HTMLQuoteElement>(null)

    useEffect(() => {
        if (!blockquoteRef.current) return

        const loadInstagramScript = () => {
            const existingScript = document.querySelector('script[src="https://www.instagram.com/embed.js"]')
            
            if (existingScript && window.instgrm) {
                setTimeout(() => {
                    window.instgrm?.Embeds.process()
                }, 500)
                return
            }

            if (existingScript) return

            const script = document.createElement('script')
            script.src = 'https://www.instagram.com/embed.js'
            script.async = true
            
            script.onload = () => {
                setTimeout(() => {
                    if (window.instgrm) {
                        window.instgrm.Embeds.process()
                    }
                }, 500)
            }

            document.body.appendChild(script)
        }

        const timer = setTimeout(() => {
            loadInstagramScript()
        }, 100)

        return () => clearTimeout(timer)
    }, [url])

    return (
        <div className="my-6 flex justify-center overflow-hidden rounded-sm">
            <blockquote
                ref={blockquoteRef}
                className="instagram-media"
                data-instgrm-captioned
                data-instgrm-permalink={url}
                data-instgrm-version="14"
                style={{
                    background: '#FFF',
                    border: '0',
                    borderRadius: '2px',
                    boxShadow: 'none',
                    margin: '0',
                    maxWidth: '540px',
                    minWidth: '326px',
                    padding: '0',
                    width: '100%',
                }}
            />
        </div>
    )
}

declare global {
    interface Window {
        instgrm?: {
            Embeds: {
                process: () => void
            }
        }
    }
}

export default InstagramEmbed
